<template>
<b-row>
  <b-col sm="6" md="2">
      <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.state"
          :options="radioOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
  </b-col>
  <b-col sm="6" md="2">
      <label class="form-control-label">{{ $t('views.excmrelation.list.finished') }}:</label>
      <b-form-group>
      <b-form-radio-group
          v-model="filters.finished"
          :options="radioOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
  </b-col>
  <b-col sm="12" md="4">
    <div class="form-group">
      <label for="contact_type_input">{{$t('views.excmrelation.list.type') }}</label>
      <model-select id="contact_type_input" :options="contactTypeOptions" v-model="filters.contactType"></model-select>
    </div>
  </b-col>
  <b-col sm="12" md="4">
    <div class="form-group">
      <label for="user_data_input">{{$t('views.excmrelation.form.userData') }}</label>
      <model-select id="user_data_input" :options="firmOptions" v-model="filters.userData"></model-select>
    </div>
  </b-col>
  <b-col md="6" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateFrom')"
                            v-model.lazy="filters['dateFrom[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="6" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateTo')"
                            v-model.lazy="filters['dateTo[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col cols="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.relationUserData')}}:</label>
      <multi-select :placeholder="$t('views.excmrelation.show.relationUserData')" @select="onSelectUserData" :options="userDataOptions" :selected-options="relationUserData"></multi-select>
    </b-form-group>
  </b-col>
</b-row>
</template>

<script>
import { ModelSelect, MultiSelect } from 'vue-search-select'
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'RelationFiltering',
  components: {
    ModelSelect,
    VueCtkDateTimePicker,
    MultiSelect
  },
  data () {
    return {
      delay: 500,
      relationUserData: [],
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      contactTypeOptions: [
        { value: 1, text: this.$t('views.excmrelation.list.relation') },
        { value: 2, text: this.$t('views.excmrelation.list.phone') },
        { value: null, text: this.$t('global.all') }
      ],
      firmOptions: [],
      lastSelectItem: {},
      userDataOptions: [],
      filters: {
        state: 1,
        finished: null,
        contactType: null,
        userData: null,
        'dateFrom[after]': '',
        'dateTo[before]': '',
        'relationUserData.userData': [],
        itemsPerPage: 10
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_c_m_relations'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  created () {
    this.fetchFirmOptions()
    this.fetchUserDataOptions()
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    async fetchFirmOptions () {
      let params = { pagination: false, isContractor: 1 }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.firmOptions = response.items.map(userData => {
        return {
          value: getId(userData['@id']),
          text: userData.firmname1 ? userData.firmname1 : userData.fullName
        }
      })
      this.firmOptions.push({ text: this.$t('global.all'), value: null })
    },
    async fetchUserDataOptions () {
      let params = { pagination: false, isContractor: 0 }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.userDataOptions = response.items.map(userData => {
        return {
          value: getId(userData['@id']),
          text: userData.fullName
        }
      })
    },
    onSelectUserData (items, lastSelectItem) {
      this.relationUserData = items
      this.filters['relationUserData.userData'] = items.map(option => getId(option.value))
      this.lastSelectItem = lastSelectItem
    }
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
